module.exports = __webpack_public_path__ + "static/media/QuickMenuIcon01_2.72d0f77a.svg";